<h2 mat-dialog-title>{{ data.header }}</h2>

<ng-scrollbar mat-dialog-content [autoHeightDisabled]="false">
  <div class="scroll-bar-margin">
    <ng-container *ngTemplateOutlet="data.template; context: { $implicit: clickClose }"></ng-container>
  </div>
</ng-scrollbar>

<div mat-dialog-actions *ngIf="!data.hideButtonBar">
  <ng-container *ngTemplateOutlet="data.extraButtons; context: { $implicit: clickClose }"></ng-container>

  <button (click)="clickClose(true)" mat-flat-button *ngIf="primaryButtonVariant === 'flat'" [color]="primaryColor">
    {{ data.yesText }}
  </button>
  <button
    (click)="clickClose(true)"
    mat-stroked-button
    *ngIf="primaryButtonVariant === 'stroked'"
    [color]="primaryColor"
  >
    {{ data.yesText }}
  </button>
  <button (click)="clickClose(true)" mat-button *ngIf="primaryButtonVariant === 'basic'" [color]="primaryColor">
    {{ data.yesText }}
  </button>

  <button mat-stroked-button *ngIf="data.noText" (click)="clickClose(false)">{{ data.noText }}</button>
</div>
